import { DynamicAssets } from "../../../../resources/DynamicAssets";

export class NoCacheDynamicAssets extends DynamicAssets {
    private readonly cacheTag: string;
    
    public constructor(cacheTag: string, autoLoad: boolean = false) {
        super(autoLoad);
        this.cacheTag = `?${cacheTag}`;
    }

    public override resource<T>(name: string): T {
        return super.resource<T>(name + this.cacheTag);
    }

    public override add(path: string): void {
        super.add(path + this.cacheTag);
    }

    public override remove(path: string): void {
        super.remove(path + this.cacheTag);    
    }

    public override has(path: string): boolean {
        return super.has(path + this.cacheTag);
    }

    public override isLoaded(path: string): boolean {
        return super.isLoaded(path + this.cacheTag);
    }
}